import React, { Fragment, useState, useEffect } from "react";
import "./EditPartnerContactModal.scss";

import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { FiPlus } from "react-icons/fi";

import {
  updatePartnerContact,
  resetUpdatePartnerContact,
} from "../../../../../store/partner/partnerContacts/partnerContactsSlice";

import DModal from "../../../../Modal/DModal/DModal";
import DInputs from "./../../../../Form/DInputs/DInputs";
import DSelect from "./../../../../Form/DSelect/DSelect";
import DPhoneInput from "../../../../Form/DPhoneInput/DPhoneInput";
import { findPhoneData } from "../../../../../helper/findPhoneData";

const EditPartnerContactModal = ({ isOpen, isClose, id, item }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    updatePartnerContactLoading,
    updatePartnerContactResult,
    updatePartnerContactError,
    getPartnerContactPositionsLoading,
    getPartnerContactPositionsSelect,
  } = useSelector((state) => state.partnerContacts);
  const { getPhoneIndexesResult, phoneIndexValueId } = useSelector((state) => state.settings);

  const [fullname, setFullname] = useState(item?.name || "");
  const [position, setPosition] = useState(
    item.position
      ? {
          label: item?.position?.name,
          value: item?.position,
        }
      : null
  );
  const [email, setEmail] = useState(item?.email || "");
  const [phone, setPhone] = useState(item?.phone || "");
  const [phoneIndex, setPhoneIndex] = useState(null);

  const submitHandler = () => {
    const data = {
      id: id,
      contactId: item.id,
      position_id: position?.value?.id || null,
      name: fullname,
      email: email,
      phone: phone,
      phone_index_id: phoneIndex?.value?.id || null,
    };
    dispatch(updatePartnerContact(data));
  };

  useEffect(() => {
    if (item?.phone) {
      const phoneIndexObj = item?.phone_index_id
        ? findPhoneData(getPhoneIndexesResult, item?.phone_index_id)
        : findPhoneData(getPhoneIndexesResult, phoneIndexValueId);

      setPhoneIndex({
        value: phoneIndexObj,
        label: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: "15px",
                height: "15px",
                backgroundImage: `url(${phoneIndexObj?.flag})`,
                backgroundPosition: "cover",
                backgroundRepeat: "no-repeat",
                marginRight: "5px",
              }}
            ></div>
            <p>{phoneIndexObj?.phone_index}</p>
          </div>
        ),
      });
    }
  }, [getPhoneIndexesResult, item, phoneIndexValueId]);

  useEffect(() => {
    if (updatePartnerContactResult) {
      dispatch(resetUpdatePartnerContact());
      isClose();
    }
  }, [dispatch, isClose, updatePartnerContactResult]);

  useEffect(() => {
    return () => {
      dispatch(resetUpdatePartnerContact());
    };
  }, [dispatch]);

  return (
    <Fragment>
      <DModal
        isOpen={isOpen}
        isClose={() => isClose()}
        onClick={() => submitHandler()}
        submitText={t("tms.modals.buttons.Save")}
        title={t("tms.modals.titles.Edit contact")}
        status='success'
        icon={<FiPlus />}
        loading={updatePartnerContactLoading}
      >
        <div id='EditPartnerContactModal'>
          <div className='formGroup'>
            <DInputs
              value={fullname}
              setValue={setFullname}
              placeholder={t("tms.modals.placeholder.Enter full name")}
              label={t("tms.modals.labels.Full name")}
              required
              id='fullname'
              error={updatePartnerContactError?.errors?.name?.[0] ?? null}
            />
            <DSelect
              id='position'
              value={position}
              setValue={setPosition}
              placeholder={t("tms.modals.placeholder.Enter position")}
              label={t("tms.modals.labels.Position")}
              options={getPartnerContactPositionsSelect}
              loading={getPartnerContactPositionsLoading}
              required
              search
              error={updatePartnerContactError?.errors?.position_id?.[0] ?? null}
            />
            <DPhoneInput
              id='PartnerContactPhone'
              value={phone}
              setValue={setPhone}
              indexValue={phoneIndex}
              setIndexValue={setPhoneIndex}
              placeholder={t("tms.modals.placeholder.Enter phone number")}
              label={t("tms.modals.labels.Phone number")}
              error={
                updatePartnerContactError?.errors?.phone?.[0] ||
                updatePartnerContactError?.errors?.phone_index_id?.[0] ||
                null
              }
            />
            <DInputs
              value={email}
              setValue={setEmail}
              placeholder={t("tms.modals.placeholder.Enter email")}
              label={t("tms.modals.labels.Email")}
              id='Email'
              error={updatePartnerContactError?.errors?.email?.[0] ?? null}
            />
          </div>
        </div>
      </DModal>
    </Fragment>
  );
};

export default EditPartnerContactModal;
